import Icon from "assets/icons";
import useTicketPrivilegesService from "./service";
import { TicketPrivilegesPropTypes } from "./types";

export default function TicketPrivileges(props: TicketPrivilegesPropTypes) {
  const service = useTicketPrivilegesService(props);

  return (
    <div className="privilegesList">
      <ul className="privilegesList_wrapper">
        {service.alreadyIncludedPrivileges.map(item => (
          <li className="privileges_item privileges_itemCurrent" key={item.id}>
            <Icon.CheckVerified /> {item.label}
          </li>
        ))}
        {service.newPrivileges.map(item => (
          <li className="privileges_item privileges_itemNew" key={item.id}>
            <Icon.CheckVerifiedFilled /> {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
